module.exports = __webpack_public_path__ + "img/1920_news_sub_img2.db8334a4.png";